import { Box, Theme, Typography } from "@outschool/backpack";
import { TFunction } from "@outschool/localization";
import { useTrackEvent } from "@outschool/ui-analytics";
import {
  ToggleButton,
  TrackingPageSection
} from "@outschool/ui-legacy-component-library";
import React from "react";

import { CategoryTutoringFiltersProps } from "./HeroFilters";

const TIME_FILTERS: Array<{ min: number; max: number }> = [
  { min: 7, max: 12 },
  { min: 12, max: 16 },
  { min: 16, max: 20 }
];

function timeString(time: number, t: TFunction) {
  switch (time) {
    case 7:
      return t("Mornings 7am - 12pm");
    case 12:
      return t("Afternoons 12pm - 4pm");
    case 16:
      return t("Evenings 4pm - 8pm");
    default:
      return t("");
  }
}
const TutoringCLPTimeFilter: React.FC<CategoryTutoringFiltersProps> = ({
  categorySlug,
  updateListings,
  label,
  t,
  searchFilters
}) => {
  const trackEvent = useTrackEvent();
  return (
    <TrackingPageSection
      name="category_time_filters"
      uniqueId={"radio_buttons"}
    >
      {setImpressionNode => (
        <Box
          flex
          sx={{
            flexWrap: "wrap",
            gap: "10px"
          }}
          ref={setImpressionNode}
        >
          <Typography
            variant="h4"
            emphasized
            sx={(theme: Theme) => ({
              width: "100%",
              padding: "12px",
              [theme.breakpoints.up("md")]: {
                borderBottom: "1px solid",
                borderColor: theme.palette.grey[300]
              },
              [theme.breakpoints.down("md")]: {
                textAlign: "center"
              }
            })}
          >
            {label}
          </Typography>
          <Box
            flex
            sx={(theme: Theme) => ({
              gap: "12px",
              justifyContent: "center",
              width: "100%",
              [theme.breakpoints.down("md")]: {
                flexWrap: "wrap"
              }
            })}
          >
            {TIME_FILTERS.map(time => {
              const enabled = searchFilters.startAfterTime === time.min;
              return (
                <ToggleButton
                  key={time.min}
                  enabled={enabled}
                  onClick={() => {
                    updateListings({ min: time.min, max: time.max });
                    trackEvent("category_filter_click", {
                      categorySlug,
                      searchFilters: { min: time.min, max: time.max }
                    });
                  }}
                  sx={{
                    marginRight: "tiny",
                    padding: "0.9rem",
                    width: "113px",
                    color: enabled ? "white" : "primary",
                    borderColor: "primary",
                    borderWidth: "2px",
                    textWrap: "wrap",
                    borderRadius: "15px !important"
                  }}
                  value={time.min}
                >
                  {timeString(time.min, t)}
                </ToggleButton>
              );
            })}
          </Box>
        </Box>
      )}
    </TrackingPageSection>
  );
};

export default TutoringCLPTimeFilter;
